import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('jv-card')
export class JvCard extends LitElement {
  static styles = css`
    :host {
      display: flex;
      flex-direction: column;
      height: 100%;
      background: var(--jv-color-surface);
      border: var(--jv-border-w) solid var(--jv-color-border);
      border-radius: var(--jv-radius);
      box-shadow: var(--jv-shadow);
      overflow: hidden;
    }
    :host([flat]) {
      box-shadow: none;
    }
    :host([lead]) {
      border-width: 3px;
      box-shadow: var(--jv-shadow-lg);
    }
    img {
      width: 100%;
      height: 150px;
      object-fit: cover;
      display: block;
      border-bottom: var(--jv-border-w) solid var(--jv-color-border);
      filter: grayscale(10%);
    }
    :host([media='tall']) img {
      height: 160px;
    }
    .body {
      padding: var(--jv-space-5);
      display: flex;
      flex-direction: column;
      gap: var(--jv-space-3);
      height: 100%;
      flex: 1;
    }
    :host([pad='none']) .body {
      padding: 0;
    }
  `;

  @property({ type: Boolean, reflect: true }) flat = false;
  @property({ type: Boolean, reflect: true }) lead = false;
  @property({ reflect: true }) pad: 'default' | 'none' = 'default';
  @property({ reflect: true }) media: 'default' | 'tall' | '' = '';
  @property() image?: string;
  @property() alt = '';

  render() {
    return html`
      ${this.image ? html`<img src=${this.image} alt=${this.alt} />` : ''}
      <div class="body">
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'jv-card': JvCard;
  }
}
